import{getProperty as r}from"../getProperty/getProperty.js";const t=(t,o)=>e=>String(r(t)(e))===o;export{t as isProperty};
//# sourceMappingURL=isProperty.js.map
